import { useCallback, useEffect, useMemo, useState } from "react";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import CheckResponsiveDesktop from "../../../../helper/fnCheckResponsiveDesktop";
import NavTitle from "../../../../components/nav-title";
import CardStyle from "../../../../components/card";
import BtnBack2 from "../../../../components/btn-back2";

import { cardStyleList, containerStyle } from "../style/locationStyles";
// import { containerStyle, cardStyleList } from "./style/locationStyles";
import { getLocationOrgs } from "../../../../services/setting/locations/location-list";
import {
  columns,
  locationListFields,
  renderLocationRow,
} from "../data/locationListFields";
import { Button, Col, Row } from "react-bootstrap";
import { TbChevronDown } from "react-icons/tb";
import { Pagination, Select } from "antd";
import GenericTable from "../../../../components/table";
import ModalApproveItem from "../../../../components/ModalApproveItem";
import SpinnerLoading from "../../../../components/spinner-loading";
import { FaRegSave } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import FormField from "../../../../components/input/form-field";

const LocationAssign = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  // const location = useLocation();
  // const orgId = location.state?.orgId;
  const orgId = searchParams.get("o");
  const activeTab = searchParams.get("at");
  const { orgRole } = useOutletContext();
  console.log("orgRole", orgRole);
  const orgName =
    orgRole &&
    orgRole.find((o) => String(o?.org_id) === searchParams.get("o"))?.org;
  const [loading, setLoading] = useState(false);
  const isDesktop = CheckResponsiveDesktop();
  const navigate = useNavigate();
  console.log("orgName", orgName);

  const [locations, setLocations] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [isCheckDisable, setIsCheckDisable] = useState(true);

  const {
    control,
    watch,
    // setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      searchList: "",
      selectOrgs: "",
    },
  });
  const searchText = watch("searchList");
  const selectedOrg = watch("selectOrgs");

  const offset = useMemo(() => (page - 1) * limit, [page, limit]);

  // ================= Fetch =================
  const fetchLocations = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = {
        limit,
        offset,
        ...(searchText ? { search: searchText } : {}),
        ...(orgId ? { orgId: Number(orgId) } : {}),
      };

      const response = await getLocationOrgs(params);

      if (!response?.status || !Array.isArray(response?.result)) {
        setLocations([]);
        setTotalRows(0);
        return;
      }

      setLocations(
        response.result.map((item) => ({
          ...item,
          is_check: item.assign === true,
        })),
      );
      setTotalRows(Number(response.total) || 0);

      // สร้าง org list จาก result (ครั้งแรก)
      if (!selectedOrg && page === 1) {
        const map = new Map();
        response.result.forEach((loc) => {
          const id = loc.office_location_id;
          if (!map.has(id)) {
            map.set(id, {
              id,
              nameEn: loc.office_location_name_en,
              nameTh: loc.office_location_name,
            });
          }
        });
        setOrganizations(Array.from(map.values()));
      }
    } catch (err) {
      console.error("Fetch locations error:", err);
      setLocations([]);
      setTotalRows(0);
    } finally {
      setIsLoading(false);
    }
  }, [limit, offset, searchText, selectedOrg, page]);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  // reset page เมื่อ filter เปลี่ยน
  useEffect(() => {
    setPage(1);
  }, [searchText, selectedOrg]);

  const handleEditLocation = useCallback(
    (id) => {
      const params = new URLSearchParams();
      params.set("id", id);
      params.set("v", 1);
      if (activeTab) {
        params.set("at", activeTab);
      }
      // if (orgId) {
      //   params.set("o", orgId);
      // }
      navigate(`/setting/location/detail?${params.toString()}`);
    },
    [navigate, activeTab],
  );

  const [showAddAll, setShowAddAll] = useState({
    isShow: false,
    data: null,
  });

  if (loading) {
    return (
      <div
        style={{
          ...containerStyle(isDesktop),
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SpinnerLoading />
      </div>
    );
  }

  const checkItem = locations.filter((item) => item.is_check).length;
  // ================= Render =================
  return (
    <div>
      {/* <div style={containerStyle(isDesktop)}> */}
      <NavTitle>
        <BtnBack2
          onClick={() => navigate(-1)}
          text={t("hrms_setting_location_topic")}
        />
      </NavTitle>

      <CardStyle style={{ ...cardStyleList(), padding: 0, marginTop: "25px" }}>
        <div
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          {/* ===== Filter + Add + Table ===== */}
          <div style={{ padding: 24 }}>
            <Row className="d-flex justify-content-between mb-3">
              <Col xl={12} className="my-auto">
                <span
                  style={{
                    fontSize: isDesktop ? 20 : 18,
                    fontWeight: 500,
                    color: "var(--color-on-base-content-high)",
                  }}
                >
                  {orgName}:
                </span>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 400,
                    color: "var(--color-on-base-content-high)",
                  }}
                >
                  {" "}
                  {t("hrms_setting_location_list_header")}
                </span>
              </Col>
              <Col
                xl={5}
                lg={5}
                md={8}
                sm={8}
                xs={8}
                style={{ marginTop: "16px" }}
              >
                {locationListFields("list", organizations).map((field) => (
                  <FormField
                    key={field.name}
                    {...field}
                    placeholder={t("hrms_setting_location_search")}
                    control={control}
                    errors={errors}
                    icon={field.icons}
                  />
                ))}
              </Col>
              <Col
                xl={7}
                lg={7}
                md={4}
                sm={4}
                xs={4}
                style={{ marginTop: "16px" }}
                className="text-end"
              >
                <Button
                  disabled={isCheckDisable}
                  onClick={() => {
                    if (!orgId) return;

                    const assign = locations
                      .filter((item) => item.is_check && !item.assign)
                      .map((item) => item.office_location_id);

                    const unassign = locations
                      .filter((item) => !item.is_check && item.assign)
                      .map((item) => item.office_location_id);

                    if (assign.length === 0 && unassign.length === 0) {
                      return;
                    }

                    setShowAddAll({
                      isShow: true,
                      data: {
                        org_id: Number(orgId),
                        assign,
                        unassign,
                      },
                    });
                  }}
                  style={{
                    height: 40,
                    padding: "0 16px",
                    borderRadius: 8,
                    fontSize: 14,
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  <FaRegSave size={20} className="me-1" />{" "}
                  {t("hrms_setting_location_save_bt")}
                </Button>
              </Col>
            </Row>

            {/* ===== Table ===== */}
            <div
              style={{
                flex: 1,
                height: "calc(100vh - 330px)",
                overflow: "auto",
              }}
            >
              <GenericTable
                rowKey="office_location_id"
                checkbox={true}
                data={locations}
                setData={setLocations}
                columns={columns}
                isLoading={isLoading}
                rowStartIndex={(page - 1) * limit}
                renderRow={(location, index, borderStyle) =>
                  renderLocationRow(
                    location,
                    index,
                    borderStyle,
                    handleEditLocation,
                    activeTab,
                    t,
                  )
                }
                visible_rows={10}
                setIsCheckDisable={setIsCheckDisable}
              />
            </div>
          </div>

          {/* ===== Pagination ===== */}
          {/* <div style={{ marginTop: "auto" }}>
              <GenericPagination
                currentPage={page}
                totalItems={totalRows}
                itemsPerPage={limit}
                onPageChange={setPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                itemsPerPageOptions={[10, 25, 50, 100]}
                maxPagesToShow={5}
                showInfo={false}
                showItemsPerPage
                size="sm"
              />
            </div> */}
          <div
            style={{
              flexShrink: 0,
              borderTop: "1px solid var(--color-base-border-default)",
              padding: "0px 12px",
              boxShadow:
                "0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: 16,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span
                  style={{
                    color: "var(--color-on-base-content-low)",
                    fontSize: 14,
                  }}
                >
                  {t("hrms_setting_location_row_page")}
                  {/* {t("tb_text_page")} */}
                </span>
                <Select
                  className="custom-select-color"
                  value={limit}
                  onChange={(limit) => {
                    setPage(1);
                    setLimit(limit);
                    // fnGetAllApproveList({
                    //   ...bodyFilter,
                    //   limit,
                    //   page: 1,
                    // });
                  }}
                  bordered={false}
                  size="small"
                  style={{
                    width: 60,
                    color: `var(--color-on-base-content-low)`,
                  }}
                  suffixIcon={
                    <TbChevronDown
                      size={22}
                      style={{
                        strokeWidth: 1.5,
                      }}
                      color={`var(--color-on-base-content-low)`}
                    />
                  }
                  options={[10, 20, 50, 100].map((n) => ({
                    value: n,
                    label: String(n),
                  }))}
                />
              </div>
              <Pagination
                size="small"
                current={page}
                pageSize={limit}
                total={totalRows}
                showSizeChanger={false}
                onChange={(p) => {
                  setPage(p);
                  // fnGetAllApproveList({
                  //   ...bodyFilter,
                  //   page: p,
                  // });
                }}
              />
            </div>
          </div>
        </div>
      </CardStyle>
      {showAddAll.isShow && (
        <ModalApproveItem
          open={showAddAll.isShow}
          data={showAddAll.data}
          fnDone={() => {
            setLocations((prev) =>
              prev.map((item) => ({
                ...item,
                is_check: false,
              })),
            );
            fetchLocations();
            navigate("/setting/location");
          }}
          onCancel={() => {
            setShowAddAll({ isShow: false });
          }}
          cancelText={t("hrms_setting_location_cancel_cf_modal")}
          confirmText={t("hrms_setting_location_yes_cf_modal")}
          title={t("hrms_setting_location_title_cf_modal")}
          subTitle={t("hrms_setting_location_sub_title_cf_modal")}
        />
      )}
    </div>
  );
};

export default LocationAssign;
